import { createClient } from '@supabase/supabase-js'
import { ENV } from './env'

const supabaseUrl = ENV.SUPABASE_URL
const supabaseAnonKey = ENV.SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey || supabaseUrl.includes('PASTE_YOUR')) {
  console.error('⚠️ Missing Supabase configuration!')
  console.log('Please edit: src/config/env.ts')
  console.log('Add your Supabase URL and Anon Key from:')
  console.log('https://supabase.com/dashboard → Settings → API')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

/**
 * Headers for calling our Edge Functions with fetch().
 * Sends the logged-in user's access token so the function can check who is calling.
 * Falls back to the anon key only when there is no session.
 */
export async function functionAuthHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession()
  return {
    Authorization: `Bearer ${session?.access_token ?? supabaseAnonKey}`,
    apikey: supabaseAnonKey,
  }
}
